/* eslint-disable */
export const animateIn = () => {
	const animateIn = document.querySelectorAll('.animate-in');
	const animateInOptions = {
		root: null,
		rootMargin: '100px',
		threshold: 0,
	};

	const animateInObserver = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('animate-in--active');
				observer.unobserve(entry.target);
			}
		});
	}, animateInOptions);

	animateIn.forEach((item) => {
		animateInObserver.observe(item);
	});
};
/* eslint-enable */
